import service from '@/services/modules/caja/caja'

export default {
  CAJA_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      service.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  CAJA_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      service.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  CAJA_GET_SALIDA(_, params) {
    return new Promise((resolve, reject) => {
      service.salida_venta_vendedor(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  CAJA_RESUMEN_CUADRE(_, params) {
    return new Promise((resolve, reject) => {
      service.resumen_caja(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
